class InputMask {
	constructor(el) {
		this.input = el;
		this.formatString = this.input.getAttribute('data-input-mask') || '$0';
		this.beforeString = this.formatString.split('$0')[0] || '';
		this.afterString = this.formatString.split('$0')[1] || '';

		this.attachHandlers();
	}

	attachHandlers = () => {
		this.input.addEventListener('focus', () => {
			this.format('focus');
			requestAnimationFrame(() => {});
		});
		this.input.addEventListener('input', () => {
			this.format('input');
		});
		this.input.addEventListener('blur', this.clearIfEmpty);
	};

	clearIfEmpty = () => {
		if (this.input.value === `${this.beforeString}${this.afterString}`) {
			this.input.value = '';
		}
	};

	format = type => {
		const beforeRegex = new RegExp(this.beforeString, 'g');
		const afterRegex = new RegExp(this.afterString, 'g');
		const ogValue = this.input.value
			.replace(beforeRegex, '')
			.replace(afterRegex, '');
		let newValue = ogValue;

		// Add the before string
		if (
			(ogValue.slice(0, this.beforeString.length) || '') !==
			this.beforeString
		) {
			newValue = `${this.beforeString}${newValue}`;
		}

		// Add the after string
		if (newValue.slice(-this.afterString.length) !== this.afterString) {
			newValue += this.afterString;
		}

		this.input.value = newValue;

		// place the cursor
		requestAnimationFrame(() => {
			const startEnd = this.input.value.length - this.afterString.length;
			if (type === 'input') {
				this.input.setSelectionRange(startEnd, startEnd);
			} else if (type === 'focus') {
				this.input.setSelectionRange(
					this.beforeString.length,
					startEnd
				);
			}
		});
	};
}

const els = Array.from(document.querySelectorAll('[data-input-mask]'));
els.forEach(el => {
	new InputMask(el);
});
